/**
 * A function to create a log object for the 'loyaltyJoinNowOrViewPoints' event (evid: 500)
 *
 * Event description: Event should be triggered when UoU clicks Join Now or View Points
 *
 * @param {loyaltyJoinNowOrViewPointsParams} params - The parameters for this event
 * @property {string} role - role of user that clicked button: owner, member, visitor
 * @property {string} button - button name user clicked: join_now, view_points, points_widget
 * @property {string} widget_id - GUID if `points_widget` is clicked
 * @return {LogObject<loyaltyJoinNowOrViewPointsParams>} LogObject<loyaltyJoinNowOrViewPointsParams>
 */
export function loyaltyJoinNowOrViewPoints(params) {
    return { evid: 500, src: 136, endpoint: 'loyalty-uou', params: params };
}
/**
 * A function to create a log object for the 'loyaltyProgramOpen' event (evid: 501)
 *
 * Event description: when Loyalty program page opens. If empty state then response from API will be in response field
 *
 * @param {loyaltyProgramOpenParams} params - The parameters for this event
 * @property {string} role - role of user that clicked button: owner, member, visitor
 * @property {string} response - API response: UNKNOWN, DRAFT, PAUSED
 * @return {LogObject<loyaltyProgramOpenParams>} LogObject<loyaltyProgramOpenParams>
 */
export function loyaltyProgramOpen(params) {
    return { evid: 501, src: 136, endpoint: 'loyalty-uou', params: params };
}
/**
 * A function to create a log object for the 'loyaltyUouClick' event (evid: 502)
 *
 * Event description: triggered when UoU click
 *
 * @param {loyaltyUouClickParams} params - The parameters for this event
 * @property {string} value - name of the button, link, toggle (etc) that was clicked by user
 * @property {string} origin - button origin (my_rewards_page, popup, etc)
 * @return {LogObject<loyaltyUouClickParams>} LogObject<loyaltyUouClickParams>
 */
export function loyaltyUouClick(params) {
    return { evid: 502, src: 136, endpoint: 'loyalty-uou', params: params };
}
/**
 * A function to create a log object for the 'loyaltyMyRewardsOpen' event (evid: 503)
 *
 * Event description: When My Rewards tab opens
 *
 * @param {loyaltyMyRewardsOpenParams} params - The parameters for this event
 * @property {string} referralInfo - where click came from
 * @property {string} availableRewards - list of reward_id (guids) that are available
 * @property {string} unavailableRewards - list of reward_id (guids) that are unavailable
 * @property {number} totalRewards - number of total rewards user can see
 * @property {number} totalPoints - number of points user has
 * @return {LogObject<loyaltyMyRewardsOpenParams>} LogObject<loyaltyMyRewardsOpenParams>
 */
export function loyaltyMyRewardsOpen(params) {
    return { evid: 503, src: 136, endpoint: 'loyalty-uou', params: params };
}
/**
 * A function to create a log object for the 'loyaltyUouApplyRewardClick' event (evid: 504)
 *
 * Event description: UoU clicks Apply Reward or redeems a coupon
 *
 * @param {loyaltyUouApplyRewardClickParams} params - The parameters for this event
 * @property {string} referralInfo - where click came from
 * @property {string} availableRewards - list of reward_id (guids) that are available
 * @property {string} unavailableRewards - list of reward_id (guids) that are unavailable
 * @property {GUID} rewardId - reward id
 * @property {string} rewardType - reward type
 * @property {number} totalRewards - number of total rewards user can see
 * @property {number} totalPoints - number of points user has
 * @property {string} rewardName - reward name that was used
 * @return {LogObject<loyaltyUouApplyRewardClickParams>} LogObject<loyaltyUouApplyRewardClickParams>
 */
export function loyaltyUouApplyRewardClick(params) {
    return { evid: 504, src: 136, endpoint: 'loyalty-uou', params: params };
}
//# sourceMappingURL=index.js.map